import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

Vue.use(Vuex)

//数据管理
const state = {
  userInfo:{},
  orderData:{},
  fulfillmentConfirmData:{},
  areaInfo:{},
  areaVersionId:''
}

const store = new Vuex.Store({
  state,      // 存储数据
  getters,    // 获取数据
  mutations,  // 数据同步更新
  actions,     // 异步更新
  plugins: [createPersistedState({
    storage: window.localStorage,
    reducer(val) {
      return {
        // 只储存state中的assessmentData
        areaInfo: val.areaInfo,
        areaVersionId: val.areaVersionId
      }
    }
  })]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js